import { render, staticRenderFns } from "./BookingPaymentSummary.vue?vue&type=template&id=15890708&scoped=true&"
import script from "./BookingPaymentSummary.vue?vue&type=script&lang=js&"
export * from "./BookingPaymentSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingPaymentSummary.vue?vue&type=style&index=0&id=15890708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15890708",
  null
  
)

export default component.exports